import { defaultNumberInputIcons } from './icons';
import { NumberInputType } from './type';
export const defaultNumberInputProps = {
    min: 0,
    max: 10,
    step: 1,
    type: NumberInputType.Spinner,
    icons: defaultNumberInputIcons
};
